import script from "./LocationManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationManagementView.vue?vue&type=script&setup=true&lang=js"

import "./LocationManagementView.vue?vue&type=style&index=0&id=44bcf448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44bcf448"]])

export default __exports__